export default __webpack_public_path__ + "static/GESSTwoBold-Bold-2b15c326cb6683d4559603a62b35b9e0.woff";